<template>
  <section v-if="!useV2026ServerSettings" class="p-3">
    <h4>จัดการ Chat Server</h4>
    <div class="py-2">
      <div class="row">
        <div class="col-lg-4 col-12">
          <div class="card">
            <div class="card-body">
              <h5 class="mb-3">รีสตาร์ท Server</h5>
              <button class="btn btn-danger btn-block" @click="displayConfirmRestartDialog()">รีสตาร์ท</button>
            </div>
          </div>
        </div>
      </div>

      <div class="row pt-3">
        <div class="col-lg-4 col-12">
          <div class="card">
            <div class="card-body">
              <h5 class="mb-3">กู้ข้อมูลแชท (กรณี Server ล่ม)</h5>
              <button class="btn btn-success btn-block"
                      :disabled="isRetrieving"
                      @click="displayConfirmRetrieveDialog()">
                {{ isRetrieving ? 'กำลังกู้ข้อมูล...' : 'กู้ข้อมูล' }}
              </button>
              <div class="pt-3" v-if="retrievedMessages">
                <b-alert show variant="info" dismissible class="mb-0">
                  จำนวนข้อความที่กู้สำเร็จ: {{ retrievedMessages.length }}
                </b-alert>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

  <section v-else class="v2026-ss">
    <h4 class="v2026-ss-title">จัดการ Chat Server</h4>

    <div class="v2026-ss-stack">
      <div class="v2026-ss-card">
        <div class="v2026-ss-card__title">รีสตาร์ท Server</div>
        <p class="v2026-ss-card__msg">รีสตาร์ท Chat Server ทั้งเครื่อง — การสนทนาที่กำลังเปิดอยู่จะขาดช่วงชั่วคราว</p>
        <button type="button"
                class="v2026-ss-btn-danger v2026-ss-btn-block"
                :disabled="isRestarting"
                @click="openConfirmV2026('restart')">รีสตาร์ท</button>
      </div>

      <div class="v2026-ss-card">
        <div class="v2026-ss-card__title">กู้ข้อมูลแชท (กรณี Server ล่ม)</div>
        <p class="v2026-ss-card__msg">ดึงข้อความที่ค้างไว้ระหว่าง Server ล่มกลับเข้าสู่ระบบ</p>
        <button type="button"
                class="v2026-ss-btn-primary v2026-ss-btn-block"
                :disabled="isRetrieving"
                @click="openConfirmV2026('retrieve')">
          {{ isRetrieving ? 'กำลังกู้ข้อมูล...' : 'กู้ข้อมูล' }}
        </button>
        <div v-if="retrievedMessages" class="v2026-ss-banner" role="status">
          <span>จำนวนข้อความที่กู้สำเร็จ: {{ retrievedMessages.length }}</span>
          <button type="button" class="v2026-ss-banner__x" aria-label="ปิด" @click="retrievedMessages = null">×</button>
        </div>
      </div>
    </div>

    <BaseConfirm :open="confirm.open"
                 :title="confirmTitle"
                 :message="confirmMessage"
                 :confirmLabel="confirmLabel"
                 cancelLabel="ยกเลิก"
                 :variant="confirm.type === 'restart' ? 'danger' : 'primary'"
                 :busy="confirm.busy"
                 @confirm="acceptConfirmV2026"
                 @cancel="cancelConfirmV2026"/>

    <BaseToast :open="toast.open"
               :variant="toast.variant"
               :title="toast.title"
               :message="toast.message"
               :autoHideDelay="toast.variant === 'danger' ? 5000 : 2500"
               @close="toast.open = false"/>
  </section>
</template>

<script>
import axios from 'axios'
import BaseConfirm from '../components/coversation/BaseConfirm'
import BaseToast from '../components/coversation/BaseToast'

export default {
  components: {
    BaseConfirm,
    BaseToast
  },
  data () {
    return {
      isRetrieving: false,
      retrievedMessages: null,
      // version2026: FALSE restores today's bootstrap page verbatim — the two .card columns,
      // btn-danger / btn-success, b-alert, and every $swal. Flipping this boolean is the
      // entire rollback.
      useV2026ServerSettings: true,
      isRestarting: false,
      confirm: {
        open: false,
        type: '',
        busy: false
      },
      toast: {
        open: false,
        variant: 'success',
        title: '',
        message: ''
      }
    }
  },
  computed: {
    confirmTitle () {
      return this.confirm.type === 'restart' ? 'รีสตาร์ท Chat Server ?' : 'กู้ข้อมูลแชท ?'
    },
    confirmMessage () {
      return this.confirm.type === 'restart'
        ? 'การสนทนาที่กำลังเปิดอยู่จะขาดช่วงชั่วคราว'
        : 'จะดึงข้อความที่ค้างไว้ระหว่าง Server ล่มกลับเข้าสู่ระบบ'
    },
    confirmLabel () {
      return this.confirm.type === 'restart' ? 'รีสตาร์ท' : 'กู้ข้อมูล'
    }
  },
  methods: {
    errorTextV2026 (err) {
      const body = err && err.response && err.response.data
      return (body && body.error) || (err && err.message) || 'เกิดข้อผิดพลาด'
    },
    showToast (variant, title, message) {
      this.toast = { open: true, variant, title, message }
    },
    openConfirmV2026 (type) {
      this.confirm = { open: true, type, busy: false }
    },
    cancelConfirmV2026 () {
      this.confirm = { open: false, type: '', busy: false }
    },
    async acceptConfirmV2026 () {
      if (this.confirm.busy) return
      if (this.confirm.type === 'restart') await this.restartV2026()
      else if (this.confirm.type === 'retrieve') await this.retrieveV2026()
    },
    async restartV2026 () {
      this.confirm.busy = true
      this.isRestarting = true
      try {
        await axios.get('/manual-restart')
        this.cancelConfirmV2026()
        this.showToast('success', 'ส่งคำสั่งรีสตาร์ทแล้ว', '')
      } catch (err) {
        this.confirm.busy = false
        this.showToast('danger', 'รีสตาร์ทไม่สำเร็จ', this.errorTextV2026(err))
      } finally {
        this.isRestarting = false
      }
    },
    async retrieveV2026 () {
      this.confirm.busy = true
      this.isRetrieving = true
      try {
        const { data } = await axios.post('/messenger-data/retrieve')
        if (data) this.retrievedMessages = data.retrieved_messages
        this.cancelConfirmV2026()
        const count = (this.retrievedMessages && this.retrievedMessages.length) || 0
        this.showToast('success', 'กู้ข้อมูลแล้ว', 'จำนวนข้อความที่กู้สำเร็จ: ' + count)
      } catch (err) {
        this.confirm.busy = false
        this.showToast('danger', 'กู้ข้อมูลไม่สำเร็จ', this.errorTextV2026(err))
      } finally {
        this.isRetrieving = false
      }
    },
    displayConfirmRestartDialog () {
      this.$swal({
        text: 'คุณต้องรีสตาร์ท Chat Server ใช่หรือไม่',
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const url = '/manual-restart'
          const { data } = await axios.get(url)
          console.log('check data', data)
        }
      })
    },
    displayConfirmRetrieveDialog () {
      this.$swal({
        text: 'คุณต้องกู้ข้อมูลแชทใช่หรือไม่',
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.retrieveChatData()
        }
      })
    },
    async retrieveChatData () {
      this.isRetrieving = true
      const url = '/messenger-data/retrieve'
      const { data } = await axios.post(url)
      this.isRetrieving = false
      if (data) {
        this.retrievedMessages = data.retrieved_messages
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Only the ten --v2026-color-* tokens declared on .v2026-shell resolve under /settings, so every
   grey below is hard-coded on purpose. */
.v2026-ss {
  padding: 16px 16px 48px;
  background: #ffffff;
}

.v2026-ss-title {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 600;
  color: #212529;
}

.v2026-ss-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 340px;
  max-width: 100%;
  margin-top: 12px;
}

.v2026-ss-card {
  padding: 16px;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  background: #ffffff;
}

.v2026-ss-card__title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  color: #212529;
}

.v2026-ss-card__msg {
  margin: 0 0 16px;
  font-size: 13px;
  line-height: 1.5;
  color: #66696C;
}

.v2026-ss-btn-block {
  width: 100%;
}

.v2026-ss-btn-primary,
.v2026-ss-btn-danger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  color: #ffffff;

  &:hover:not(:disabled) { filter: brightness(.94); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
  &:disabled { opacity: .5; cursor: default; }
}

.v2026-ss-btn-primary { background: var(--v2026-color-main); }
.v2026-ss-btn-danger { background: #E5484D; }

.v2026-ss-banner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid var(--v2026-color-main);
  border-radius: 8px;
  background: var(--v2026-color-main-soft);
  font-size: 13px;
  color: #212529;
}

.v2026-ss-banner__x {
  margin-left: auto;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 6px;
  background: none;
  font-size: 16px;
  line-height: 1;
  color: #66696C;
  cursor: pointer;

  &:hover { background: #ffffff; color: #212529; }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
}
</style>
